import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { map, find, isEmpty } from 'lodash';
let default_1 = class default_1 extends Vue {
    tree;
    treeData;
    placeholder;
    selectedList;
    disabled;
    get selectedLabels() {
        if (this.disabled) {
            return [];
        }
        return map(this.selectedList, 'label');
    }
    set selectedLabels(data) {
    }
    onSelectedList(newList, oldList) {
        if (isEmpty(oldList) && !isEmpty(newList)) {
            this.setInitialSelected(newList);
        }
    }
    removeTagByName(label) {
        if (this.disabled) {
            return;
        }
        const item = find(this.selectedList, item => item.label === label) || {};
        this.$refs.tree.setChecked(item.key, false);
        this.handleCheckChange();
    }
    handleCheckChange() {
        if (this.disabled) {
            return;
        }
        const checkedList = this.$refs.tree.getCheckedNodes(true);
        this.$emit('update:selectedList', map(checkedList, ({ id, key, label }) => ({ id, key, label })));
    }
    mounted() {
        this.setInitialSelected();
    }
    setInitialSelected(selectedList) {
        this.$refs.tree.setCheckedKeys(map(selectedList || this.selectedList, 'key'));
    }
};
__decorate([
    Ref()
], default_1.prototype, "tree", void 0);
__decorate([
    Prop()
], default_1.prototype, "treeData", void 0);
__decorate([
    Prop()
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop()
], default_1.prototype, "selectedList", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "disabled", void 0);
__decorate([
    Watch('selectedList')
], default_1.prototype, "onSelectedList", null);
default_1 = __decorate([
    Component({
        name: 'TreeSelect',
        i18n: {
            messages: { en: {} }
        }
    })
], default_1);
export default default_1;
